<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <h1 class="md-title">Rankings</h1>
        <br />
        <md-table v-model="fullRanking.avgGameTime" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Tiempo de juego promedio</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value | msToSec }} s.</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.avgQuestionTime" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Tiempo de pregunta promedio</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value | msToSec }} s.</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.bestCoinsWonPct" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Mejor porcentaje de monedas ganadas</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} %</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.bestOkPct" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Mejor porcentaje de respuestas correctas</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} %</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.coins" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Cantidad de monedas ganadas</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} monedas</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.coinsTotal" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Cantidad de monedas en juego</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} monedas</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.fastestGame" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Juego más rápido</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value | msToSec }} s.</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.fastestQuestion" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Pregunta mas rápida</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value | msToSec }} s.</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.games" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Cantidad de juegos</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} juegos</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.questions" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Cantidad de respuestas</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} resp.</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.questionsError" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Cantidad de respuestas erroneas</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} errores</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.questionsOk" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Cantidad de respuestas correctas</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} aciertos</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.slowestGame" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Juego más lento</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value | msToSec }} s.</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.slowestQuestion" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Pregunta más lenta</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value | msToSec }} s.</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.worstCoinsWonPct" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Peor porcentaje de monedas ganadas</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} %</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>

        <md-divider style="margin-bottom: 50px;"></md-divider>

        <md-table v-model="fullRanking.worstOkPct" md-card>
            <md-table-toolbar>
                <div>
                    <h1 class="md-subheading">Peor porcentaje de respuestas correctas</h1>
                </div>
            </md-table-toolbar>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Ubicación" width="10%">{{ item.position }}</md-table-cell>
                <md-table-cell md-label="Jugador">{{ item.playername }}</md-table-cell>
                <md-table-cell md-label="Valor" md-numeric>{{ item.value }} %</md-table-cell>
                <md-table-cell md-label="Fecha" width="20%">{{ item.date | formatDate }}</md-table-cell>
            </md-table-row>
        </md-table>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-menu-content.md-select-menu {
    width: auto;
    max-width: none;
  }
</style>

<script>
import Vue from 'vue'
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'
import axios from "axios";

export default {
    name: 'MAP',
    components: {
        Header, Menu
    },
    data () {
      return {
        menuVisible: false,
        loading: false,
        fullRanking: [],
        ranking: [],
        form: {
            rankType: 'coins'
        }
      }
    },
    watch: {
        '$route': 'fetchData'
    },
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
            if (liuser) {
                console.log('User logged in, go ahead...');
                var that = this;
                user.init(firebase.auth().currentUser, () => {
                    that.fetchData();
                });
            } else {
                this.$router.push('/auth')
                console.log('User not logged in!');
            }
        });
    },
    methods: {
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            this.fullRanking = [];
            this.ranking = [];
            this.loading = true;

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/rankings/quickgame/0/10", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result.data);
                    this.loading = false;
                    this.fullRanking = result.data;

                    console.log(this.fullRanking);
                    this.selectRank();
                }, error => {
                    console.error(error);
                    this.loading = false;
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        selectRank () {
            console.log(this.form.rankType);
            this.ranking = this.fullRanking[this.form.rankType];
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Rankings.vue